import { render } from "./HomeSubtitle.vue?vue&type=template&id=4cd91e26&scoped=true"
import script from "./HomeSubtitle.vue?vue&type=script&lang=js"
export * from "./HomeSubtitle.vue?vue&type=script&lang=js"

import "./HomeSubtitle.vue?vue&type=style&index=0&id=4cd91e26&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd91e26"]])

export default __exports__